<template>
  <svg :width="width" :height="height" :viewBox="'0 0 ' + width + ' ' + height">
    <template v-if="points">
      <polyline :points="points.line" fill="none" stroke="#FF5700" stroke-width="1.8" stroke-linejoin="round" />
      <polygon :points="points.area" fill="rgba(255,87,0,.07)" stroke="none" />
    </template>
  </svg>
</template>

<script>
/** The 12-month sparkline of a card / table row: `points` from metricsCalc.sparkline(). */
export default {
  name: 'MetricsSparkline',
  props: {
    points: { type: Object, default: null },
    width: { type: Number, default: 180 },
    height: { type: Number, default: 38 },
  },
}
</script>
